import { faX } from "@fortawesome/free-solid-svg-icons"
import IconButton from "./IconButton"
import { Badge } from "./ui/badge"
import { cn } from "@lib/utils"

export const Tag = (
  {
    text,
    backgroundColorClassName,
    isRemovable,
    removeTagCallback,
    type,
    style,
  }
  :
  {
    text: string,
    backgroundColorClassName?: string,
    isRemovable?: boolean,
    removeTagCallback?: () => void,
    type?: "categoryTag",
    style?: string,
  }
) => {

  return (
    <Badge
      variant={type === "categoryTag" ? "category" : "default"}
      className={cn(
        backgroundColorClassName,
        style,
      )}
    >
      {text}
      {
        isRemovable && removeTagCallback &&
        <IconButton
          icon={faX}
          actionCallback={removeTagCallback}
          style="text-text/70 hover:text-text w-[10px] pl-1"
        />
      }
    </Badge>
  )
}
